import { SPSELECTS } from "InterfacesTypes/enums";
import type { ISharepointSearchResponse, ILatestUpdatedPages, ISharepointSearchRow } from "InterfacesTypes/interfaces";
import type { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchFailure,
  fetchRecentlyUpdatedPages,
  fetchStart,
  fetchSuccess,
} from "state/reducers/RecentlyUpdatedPagesReducer";
import { spGet, spPost } from "utils/SharepointAPI";
import { getEnvironment } from "utils/utils";

const env = getEnvironment();

// const getLatestUpdatedPagesUrl = `/_api/search/query?querytext='FileExtension:aspx AND IsDocument:1 AND Path:https://logp.fmv.se/*'&RowLimit=50&SortList='Write:descending'`;
// const test = `POST https://logp.fmv.se/_api/search/postquery Content-Type: application/json;odata=verbose`
const latestPageQueryText = `Path:"https://logp.fmv.se/*" AND FileExtension:aspx AND IsDocument:1 AND NOT ContentClass:STS_ListItem_DocumentLibrary AND NOT (Path:"https://logp.fmv.se/tjansterprodukter/VSDL/*" OR Path:"https://logp.fmv.se/tjansterprodukter/dev/*" OR Path:"https://gap.fmv.se/*" OR Path:"https://logp.fmv.se/tjansterprodukter/VSDLAT/*" OR Path:"https://logp.fmv.se/tjansterprodukter/internationellspedition/*" OR Path:"https://logp.fmv.se/tjansterprodukter/Testsammanfattningar/*" OR Path:"https://logp.fmv.se/tjansterprodukter/certifikat/*")`; 

function* fetchRecentlyUpdatedPagesWorker() {
  try {
    yield put(fetchStart());
    if (window.location.hostname === "localhost") {
      const updatedPagesUrl = `${env.listapi}/GetByTitle('RecentlyUpdatedPages')/Items?$top=5000&$select=${SPSELECTS.RECENTLYUPDATEDPAGES}`;
      const data: ILatestUpdatedPages[] = yield call(spGet, updatedPagesUrl);
      yield put(fetchSuccess(data));
    } else {
      const response: ISharepointSearchResponse = yield call(spPost, env.baseUrl + "/_api/search/postquery", createRequest(latestPageQueryText));
      //console.log("RESPONSE", response);
      const latestPages: ILatestUpdatedPages[] = response.PrimaryQueryResult.RelevantResults.Table.Rows.map((row: ISharepointSearchRow): ILatestUpdatedPages => {
        const cells = row.Cells.reduce<Record<string, string>>((acc, cell) => {
          acc[cell.Key] = cell.Value;
          return acc;
        }, {});

        return {
          Title: cells.Title?? "",
          Author: cells.Author?? "",
          Path: cells.Path?? "",
          Write: new Date(cells.Write?? "0000-00-00"),
          LastModifiedTime: new Date(cells.LastModifiedTime?? "0000-00-00"),
          ContentClass: cells.ContentClass?? "",
          FileExtension: cells.FileExtension?? "",
          OriginalPath: cells.OriginalPath?? "",
          SPWebUrl: cells.SPWebUrl?? "",
        };
      });

      //console.log("SENASTE SIDORNA", latestPages);

      const siteTitleMap: Record<string, string> = yield call(fetchSiteTitles, latestPages);

      const completedPageObjects = latestPages.map(x => ({
        ...x,
        SiteTitle: siteTitleMap[x.SPWebUrl?? ""] ?? "",
      }));

      yield put(fetchSuccess(completedPageObjects));
    }
  } catch (err: unknown) {
    if (err instanceof Error ) {
      console.error("Something went wrong in recently updated pages saga: ", err?.message ?? "could not find any error message");
      yield put(fetchFailure(err?.message ?? "Något gick fel"));
    }
  }
}

function createRequest(queryText: string) {
  const request = {
    request: {
      "Querytext": queryText,
    RowLimit: 100,
    SortList: [
      {
        Property: "Write",
        Direction: 1,
      }
    ],
    SelectProperties: [
        "Title",
        "Path",
        "Write",
        "LastModifiedTime",
        "ContentClass",
        "FileExtension",
        "OriginalPath",
        "Author",
        "SPWebUrl",
      ]
    }
  }
  return request;
}

export function* recentlyUpdatedPagesSaga() {
  yield takeLatest(
    fetchRecentlyUpdatedPages.type,
    fetchRecentlyUpdatedPagesWorker
  );
}


function* fetchSiteTitles(
    results: ILatestUpdatedPages[]
): SagaIterator<Record<string, string>> {
    const uniqueSpUrls = Array.from(
        new Set(results.map(x => x.SPWebUrl).filter(Boolean))
    );
    const siteTitleMap: Record<string, string> = {};

    for (const spUrl of uniqueSpUrls) {
        try{
            const title = yield call(spGet, `${spUrl}/_api/web?$select=Title`);
            siteTitleMap[spUrl?? ""] = title.Title;
        } catch (e) {
            console.log("Error in 'fetchSiteTitles': ", e);
            siteTitleMap[spUrl?? ""] = "";
        }
    }


    return siteTitleMap;
}